module.exports = __webpack_public_path__ + "static/media/user_default.9a3a77b0.svg";